import {GoalsViewId, GoalsViewTitle} from "../../../../../core/gd-modules/goals/types/types"
import {PopoverMenuItemType} from "../../../../../core/gd-components/popover-menu/popover-menu/const"

export const goalsListViews = [
    {
        value   : GoalsViewId.ACTIVE,
        icon    : 'i5-goals',
        label   : GoalsViewTitle[GoalsViewId.ACTIVE],
    },
    {
        value   : GoalsViewId.ASSIGNED_GOALS,
        icon    : 'i5-goals-assigne',
        label   : GoalsViewTitle[GoalsViewId.ASSIGNED_GOALS],
    }, {
        value   : GoalsViewId.OWNED_GOALS,
        icon    : 'i5-goals-own',
        label   : GoalsViewTitle[GoalsViewId.OWNED_GOALS],
    },
    {
        type    : PopoverMenuItemType.SEPARATOR
    },
    {
        value   : GoalsViewId.ARCHIVED_GOALS,
        icon    : 'i5-goals-archive',
        label   : GoalsViewTitle[GoalsViewId.ARCHIVED_GOALS],
    }, {
        value   : GoalsViewId.ALL,
        icon    : 'i5-goals',
        label   : GoalsViewTitle[GoalsViewId.ALL],
    },
]